import React from 'react'
import classnames from 'classnames'

import { Item } from '../../../core/items'
import { manufacturingInfoTableContent } from './each-item-content'
import styles from '../../styles/modules/table.module.scss'

interface Props {
  item: Item
}

const ManufacturingInfoTable: React.FC<Props> = props => (
  <div
    className={classnames({
      [styles.wrapper]: true,
      [styles.stocker]: true,
    })}
  >
    <table className={styles.container}>
      <tbody>
        <tr className={styles.rowStatic}>
          <td className={styles.cell}>
            {manufacturingInfoTableContent.beanTypeIndex}
          </td>
          <td className={styles.cell}>{props.item.beanTypeIndex}</td>
        </tr>
        <tr className={styles.rowStatic}>
          <td className={styles.cell}>
            {manufacturingInfoTableContent.beanAmount}
          </td>
          <td className={styles.cell}>{props.item.beanAmount}</td>
        </tr>
        <tr className={styles.rowStatic}>
          <td className={styles.cell}>
            {manufacturingInfoTableContent.machineButtonIndex}
          </td>
          <td className={styles.cell}>{props.item.machineButtonIndex}</td>
        </tr>
      </tbody>
    </table>
  </div>
)

export default ManufacturingInfoTable
